const tsDataScience = {
  scale1: {
    "Assumptions, Strengths & Weaknesses": null,
    "Compare Models": null,
    "Consistency of Hypotheses, Predictions & Conclusions": 0.0,
    "Model Information": 0.0,
    "New Information & Predictions in Models": 0.0,
    "Support of Hypotheses": 0.0,
    "Support or Weakening of Models": null,
    "Compare or Combine": 0.0,
    "Creating Figures": 0.0,
    "Interpolation & Extrapolation": 0.0,
    "New Information": 0.0,
    "Select Data & Features": 0.0,
    Terminology: 0.0,
    "Text & Representations": 0.0,
    "Variables & Mathematical Relationships": 0.0,
    Comparison: 0.0,
    Control: 0.0,
    Hypothesis: null,
    Methods: 0.0,
    "Precision & Accuracy": null,
    "Prediction & Further Experiments": 0.0,
    "Text & Experiments": null,
    Tools: 0.0,
    "Understanding Design": 0.0
  },
  scale2: {
    "Assumptions, Strengths & Weaknesses": null,
    "Compare Models": null,
    "Consistency of Hypotheses, Predictions & Conclusions": null,
    "Model Information": null,
    "New Information & Predictions in Models": null,
    "Support of Hypotheses": null,
    "Support or Weakening of Models": null,
    "Compare or Combine": null,
    "Creating Figures": null,
    "Interpolation & Extrapolation": null,
    "New Information": null,
    "Select Data & Features": null,
    Terminology: null,
    "Text & Representations": null,
    "Variables & Mathematical Relationships": null,
    Comparison: null,
    Control: null,
    Hypothesis: null,
    Methods: null,
    "Precision & Accuracy": null,
    "Prediction & Further Experiments": null,
    "Text & Experiments": null,
    Tools: null,
    "Understanding Design": null
  },
  scale3: {
    "Assumptions, Strengths & Weaknesses": null,
    "Compare Models": null,
    "Consistency of Hypotheses, Predictions & Conclusions": 0.04,
    "Model Information": 0.00574713,
    "New Information & Predictions in Models": 0.015625,
    "Support of Hypotheses": 0.0351563,
    "Support or Weakening of Models": null,
    "Compare or Combine": 0.012931,
    "Creating Figures": 0.0,
    "Interpolation & Extrapolation": 0.0,
    "New Information": 0.0258621,
    "Select Data & Features": 0.0413793,
    Terminology: 0.0,
    "Text & Representations": 0.0,
    "Variables & Mathematical Relationships": 0.00933908,
    Comparison: 0.137931,
    Control: 0.109375,
    Hypothesis: null,
    Methods: 0.0,
    "Precision & Accuracy": null,
    "Prediction & Further Experiments": 0.00431034,
    "Text & Experiments": null,
    Tools: 0.0,
    "Understanding Design": 0.0215517
  },
  scale4: {
    "Assumptions, Strengths & Weaknesses": null,
    "Compare Models": null,
    "Consistency of Hypotheses, Predictions & Conclusions": null,
    "Model Information": 0,
    "New Information & Predictions in Models": 0.0305344,
    "Support of Hypotheses": 0.028626,
    "Support or Weakening of Models": null,
    "Compare or Combine": 0,
    "Creating Figures": 0,
    "Interpolation & Extrapolation": 0,
    "New Information": 0,
    "Select Data & Features": 0,
    Terminology: 0,
    "Text & Representations": 0.0209924,
    "Variables & Mathematical Relationships": 0,
    Comparison: 0,
    Control: 0.0534351,
    Hypothesis: null,
    Methods: null,
    "Precision & Accuracy": null,
    "Prediction & Further Experiments": 0,
    "Text & Experiments": null,
    Tools: 0,
    "Understanding Design": 0
  },
  scale5: {
    "Assumptions, Strengths & Weaknesses": null,
    "Compare Models": null,
    "Consistency of Hypotheses, Predictions & Conclusions": 0.0761905,
    "Model Information": 0,
    "New Information & Predictions in Models": null,
    "Support of Hypotheses": null,
    "Support or Weakening of Models": null,
    "Compare or Combine": 0,
    "Creating Figures": 0,
    "Interpolation & Extrapolation": 0,
    "New Information": 0,
    "Select Data & Features": 0,
    Terminology: 0,
    "Text & Representations": null,
    "Variables & Mathematical Relationships": 0,
    Comparison: 0,
    Control: null,
    Hypothesis: null,
    Methods: 0.0,
    "Precision & Accuracy": null,
    "Prediction & Further Experiments": 0,
    "Text & Experiments": null,
    Tools: 0,
    "Understanding Design": 0
  },
  scale6: {
    "Assumptions, Strengths & Weaknesses": null,
    "Compare Models": null,
    "Consistency of Hypotheses, Predictions & Conclusions": 0.0947368,
    "Model Information": 0.0383838,
    "New Information & Predictions in Models": 0.080402,
    "Support of Hypotheses": 0.0565327,
    "Support or Weakening of Models": null,
    "Compare or Combine": 0.0816162,
    "Creating Figures": 0.0581818,
    "Interpolation & Extrapolation": 0.0509091,
    "New Information": 0.0654545,
    "Select Data & Features": 0.116323,
    Terminology: 0.0420202,
    "Text & Representations": 0.040201,
    "Variables & Mathematical Relationships": 0.0624242,
    Comparison: 0.144242,
    Control: 0.150754,
    Hypothesis: null,
    Methods: 0.0,
    "Precision & Accuracy": null,
    "Prediction & Further Experiments": 0.0533333,
    "Text & Experiments": null,
    Tools: 0.0218182,
    "Understanding Design": 0.100606
  },
  scale7: {
    "Assumptions, Strengths & Weaknesses": null,
    "Compare Models": null,
    "Consistency of Hypotheses, Predictions & Conclusions": 0.157143,
    "Model Information": 0.0699469,
    "New Information & Predictions in Models": 0.0969697,
    "Support of Hypotheses": 0.0871212,
    "Support or Weakening of Models": null,
    "Compare or Combine": 0.0926194,
    "Creating Figures": 0.0734443,
    "Interpolation & Extrapolation": 0.065123,
    "New Information": 0.0419682,
    "Select Data & Features": 0.143849,
    Terminology: 0.0902074,
    "Text & Representations": 0.0643939,
    "Variables & Mathematical Relationships": 0.0664496,
    Comparison: 0.198987,
    Control: 0.0727273,
    Hypothesis: null,
    Methods: 0.0714286,
    "Precision & Accuracy": null,
    "Prediction & Further Experiments": 0.0575253,
    "Text & Experiments": null,
    Tools: 0.0340087,
    "Understanding Design": 0.153401
  },
  scale8: {
    "Assumptions, Strengths & Weaknesses": null,
    "Compare Models": null,
    "Consistency of Hypotheses, Predictions & Conclusions": null,
    "Model Information": 0,
    "New Information & Predictions in Models": 0.153731,
    "Support of Hypotheses": 0.115299,
    "Support or Weakening of Models": null,
    "Compare or Combine": 0,
    "Creating Figures": 0,
    "Interpolation & Extrapolation": 0,
    "New Information": 0,
    "Select Data & Features": 0,
    Terminology: 0,
    "Text & Representations": 0.0850746,
    "Variables & Mathematical Relationships": 0,
    Comparison: 0,
    Control: 0.107463,
    Hypothesis: null,
    Methods: null,
    "Precision & Accuracy": null,
    "Prediction & Further Experiments": 0,
    "Text & Experiments": null,
    Tools: 0,
    "Understanding Design": 0
  },
  scale9: {
    "Assumptions, Strengths & Weaknesses": null,
    "Compare Models": null,
    "Consistency of Hypotheses, Predictions & Conclusions": 0.179149,
    "Model Information": 0.144603,
    "New Information & Predictions in Models": 0.171569,
    "Support of Hypotheses": 0.128268,
    "Support or Weakening of Models": null,
    "Compare or Combine": 0.126261,
    "Creating Figures": 0.135086,
    "Interpolation & Extrapolation": 0.12572,
    "New Information": 0.105728,
    "Select Data & Features": 0.188959,
    Terminology: 0.136347,
    "Text & Representations": 0.152574,
    "Variables & Mathematical Relationships": 0.119597,
    Comparison: 0.17129,
    Control: 0.13317,
    Hypothesis: null,
    Methods: 0.087234,
    "Precision & Accuracy": null,
    "Prediction & Further Experiments": 0.126171,
    "Text & Experiments": null,
    Tools: 0.0904179,
    "Understanding Design": 0.144813
  },
  scale10: {
    "Assumptions, Strengths & Weaknesses": null,
    "Compare Models": null,
    "Consistency of Hypotheses, Predictions & Conclusions": 0.212178,
    "Model Information": 0.175779,
    "New Information & Predictions in Models": 0.19613,
    "Support of Hypotheses": 0.149712,
    "Support or Weakening of Models": null,
    "Compare or Combine": 0.144949,
    "Creating Figures": 0.147434,
    "Interpolation & Extrapolation": 0.16698,
    "New Information": 0.119828,
    "Select Data & Features": 0.207617,
    Terminology: 0.172577,
    "Text & Representations": 0.168933,
    "Variables & Mathematical Relationships": 0.14318,
    Comparison: 0.236029,
    Control: 0.150105,
    Hypothesis: null,
    Methods: 0.0936768,
    "Precision & Accuracy": null,
    "Prediction & Further Experiments": 0.150121,
    "Text & Experiments": null,
    Tools: 0.125873,
    "Understanding Design": 0.164428
  },
  scale11: {
    "Assumptions, Strengths & Weaknesses": null,
    "Compare Models": null,
    "Consistency of Hypotheses, Predictions & Conclusions": 0.236095,
    "Model Information": 0.191974,
    "New Information & Predictions in Models": 0.216167,
    "Support of Hypotheses": 0.161302,
    "Support or Weakening of Models": null,
    "Compare or Combine": 0.176264,
    "Creating Figures": 0.17119,
    "Interpolation & Extrapolation": 0.195351,
    "New Information": 0.149642,
    "Select Data & Features": 0.23757,
    Terminology: 0.206553,
    "Text & Representations": 0.19925,
    "Variables & Mathematical Relationships": 0.154441,
    Comparison: 0.250688,
    Control: 0.179225,
    Hypothesis: null,
    Methods: 0.121302,
    "Precision & Accuracy": null,
    "Prediction & Further Experiments": 0.177975,
    "Text & Experiments": null,
    Tools: 0.132312,
    "Understanding Design": 0.193105
  },
  scale12: {
    "Assumptions, Strengths & Weaknesses": null,
    "Compare Models": null,
    "Consistency of Hypotheses, Predictions & Conclusions": 0.250515,
    "Model Information": 0.207533,
    "New Information & Predictions in Models": 0.240597,
    "Support of Hypotheses": 0.187638,
    "Support or Weakening of Models": null,
    "Compare or Combine": 0.193807,
    "Creating Figures": 0.203878,
    "Interpolation & Extrapolation": 0.212765,
    "New Information": 0.159905,
    "Select Data & Features": 0.268174,
    Terminology: 0.2543,
    "Text & Representations": 0.231748,
    "Variables & Mathematical Relationships": 0.172102,
    Comparison: 0.280605,
    Control: 0.169524,
    Hypothesis: null,
    Methods: 0.136598,
    "Precision & Accuracy": null,
    "Prediction & Further Experiments": 0.210794,
    "Text & Experiments": null,
    Tools: 0.156035,
    "Understanding Design": 0.212514
  },
  scale13: {
    "Assumptions, Strengths & Weaknesses": null,
    "Compare Models": null,
    "Consistency of Hypotheses, Predictions & Conclusions": 0.260778,
    "Model Information": 0.252589,
    "New Information & Predictions in Models": 0.266885,
    "Support of Hypotheses": 0.202832,
    "Support or Weakening of Models": null,
    "Compare or Combine": 0.208812,
    "Creating Figures": 0.22172,
    "Interpolation & Extrapolation": 0.236343,
    "New Information": 0.17139,
    "Select Data & Features": 0.301225,
    Terminology: 0.285137,
    "Text & Representations": 0.266667,
    "Variables & Mathematical Relationships": 0.194843,
    Comparison: 0.301696,
    Control: 0.21024,
    Hypothesis: null,
    Methods: 0.177708,
    "Precision & Accuracy": null,
    "Prediction & Further Experiments": 0.234267,
    "Text & Experiments": null,
    Tools: 0.153807,
    "Understanding Design": 0.225504
  },
  scale14: {
    "Assumptions, Strengths & Weaknesses": null,
    "Compare Models": null,
    "Consistency of Hypotheses, Predictions & Conclusions": 0.290639,
    "Model Information": 0.279911,
    "New Information & Predictions in Models": 0.294204,
    "Support of Hypotheses": 0.216535,
    "Support or Weakening of Models": null,
    "Compare or Combine": 0.236102,
    "Creating Figures": 0.228342,
    "Interpolation & Extrapolation": 0.240946,
    "New Information": 0.188911,
    "Select Data & Features": 0.341829,
    Terminology: 0.308462,
    "Text & Representations": 0.283309,
    "Variables & Mathematical Relationships": 0.196084,
    Comparison: 0.354684,
    Control: 0.232902,
    Hypothesis: null,
    Methods: 0.187215,
    "Precision & Accuracy": null,
    "Prediction & Further Experiments": 0.259837,
    "Text & Experiments": null,
    Tools: 0.172423,
    "Understanding Design": 0.24905
  },
  scale15: {
    "Assumptions, Strengths & Weaknesses": null,
    "Compare Models": null,
    "Consistency of Hypotheses, Predictions & Conclusions": 0.31589,
    "Model Information": 0.297887,
    "New Information & Predictions in Models": 0.32947,
    "Support of Hypotheses": 0.24881,
    "Support or Weakening of Models": null,
    "Compare or Combine": 0.254524,
    "Creating Figures": 0.256075,
    "Interpolation & Extrapolation": 0.27107,
    "New Information": 0.188595,
    "Select Data & Features": 0.381367,
    Terminology: 0.362869,
    "Text & Representations": 0.306861,
    "Variables & Mathematical Relationships": 0.209738,
    Comparison: 0.398369,
    Control: 0.245033,
    Hypothesis: null,
    Methods: 0.169492,
    "Precision & Accuracy": null,
    "Prediction & Further Experiments": 0.255664,
    "Text & Experiments": null,
    Tools: 0.181261,
    "Understanding Design": 0.290937
  },
  scale16: {
    "Assumptions, Strengths & Weaknesses": null,
    "Compare Models": null,
    "Consistency of Hypotheses, Predictions & Conclusions": 0.343952,
    "Model Information": 0.32119,
    "New Information & Predictions in Models": 0.344726,
    "Support of Hypotheses": 0.270201,
    "Support or Weakening of Models": null,
    "Compare or Combine": 0.270781,
    "Creating Figures": 0.265216,
    "Interpolation & Extrapolation": 0.304146,
    "New Information": 0.21333,
    "Select Data & Features": 0.427598,
    Terminology: 0.388494,
    "Text & Representations": 0.311793,
    "Variables & Mathematical Relationships": 0.223605,
    Comparison: 0.431059,
    Control: 0.273653,
    Hypothesis: null,
    Methods: 0.216766,
    "Precision & Accuracy": null,
    "Prediction & Further Experiments": 0.283476,
    "Text & Experiments": null,
    Tools: 0.163071,
    "Understanding Design": 0.319152
  },
  scale17: {
    "Assumptions, Strengths & Weaknesses": null,
    "Compare Models": null,
    "Consistency of Hypotheses, Predictions & Conclusions": 0.369052,
    "Model Information": 0.350638,
    "New Information & Predictions in Models": 0.370293,
    "Support of Hypotheses": 0.289201,
    "Support or Weakening of Models": null,
    "Compare or Combine": 0.301962,
    "Creating Figures": 0.305054,
    "Interpolation & Extrapolation": 0.32726,
    "New Information": 0.223556,
    "Select Data & Features": 0.480865,
    Terminology: 0.427993,
    "Text & Representations": 0.340638,
    "Variables & Mathematical Relationships": 0.243326,
    Comparison: 0.502036,
    Control: 0.348904,
    Hypothesis: null,
    Methods: 0.218814,
    "Precision & Accuracy": null,
    "Prediction & Further Experiments": 0.300895,
    "Text & Experiments": null,
    Tools: 0.182138,
    "Understanding Design": 0.368557
  },
  scale18: {
    "Assumptions, Strengths & Weaknesses": null,
    "Compare Models": null,
    "Consistency of Hypotheses, Predictions & Conclusions": 0.408917,
    "Model Information": 0.376961,
    "New Information & Predictions in Models": 0.433024,
    "Support of Hypotheses": 0.317888,
    "Support or Weakening of Models": null,
    "Compare or Combine": 0.307122,
    "Creating Figures": 0.352163,
    "Interpolation & Extrapolation": 0.374135,
    "New Information": 0.247232,
    "Select Data & Features": 0.552584,
    Terminology: 0.48786,
    "Text & Representations": 0.359416,
    "Variables & Mathematical Relationships": 0.248919,
    Comparison: 0.560208,
    Control: 0.436008,
    Hypothesis: null,
    Methods: 0.211783,
    "Precision & Accuracy": null,
    "Prediction & Further Experiments": 0.321107,
    "Text & Experiments": null,
    Tools: 0.192042,
    "Understanding Design": 0.455363
  },
  scale19: {
    "Assumptions, Strengths & Weaknesses": null,
    "Compare Models": null,
    "Consistency of Hypotheses, Predictions & Conclusions": 0.435862,
    "Model Information": 0.408944,
    "New Information & Predictions in Models": 0.4724,
    "Support of Hypotheses": 0.34572,
    "Support or Weakening of Models": null,
    "Compare or Combine": 0.343331,
    "Creating Figures": 0.376824,
    "Interpolation & Extrapolation": 0.421787,
    "New Information": 0.253352,
    "Select Data & Features": 0.609186,
    Terminology: 0.52914,
    "Text & Representations": 0.367687,
    "Variables & Mathematical Relationships": 0.27315,
    Comparison: 0.654569,
    Control: 0.4908,
    Hypothesis: null,
    Methods: 0.293596,
    "Precision & Accuracy": null,
    "Prediction & Further Experiments": 0.345673,
    "Text & Experiments": null,
    Tools: 0.204028,
    "Understanding Design": 0.504389
  },
  scale20: {
    "Assumptions, Strengths & Weaknesses": null,
    "Compare Models": null,
    "Consistency of Hypotheses, Predictions & Conclusions": 0.46948,
    "Model Information": 0.443681,
    "New Information & Predictions in Models": 0.563798,
    "Support of Hypotheses": 0.408079,
    "Support or Weakening of Models": null,
    "Compare or Combine": 0.369233,
    "Creating Figures": 0.412925,
    "Interpolation & Extrapolation": 0.512746,
    "New Information": 0.302972,
    "Select Data & Features": 0.665115,
    Terminology: 0.601432,
    "Text & Representations": 0.399312,
    "Variables & Mathematical Relationships": 0.299427,
    Comparison: 0.720802,
    Control: 0.607499,
    Hypothesis: null,
    Methods: 0.309423,
    "Precision & Accuracy": null,
    "Prediction & Further Experiments": 0.357608,
    "Text & Experiments": null,
    Tools: 0.221196,
    "Understanding Design": 0.60666
  },
  scale21: {
    "Assumptions, Strengths & Weaknesses": null,
    "Compare Models": null,
    "Consistency of Hypotheses, Predictions & Conclusions": 0.474462,
    "Model Information": 0.488851,
    "New Information & Predictions in Models": 0.599776,
    "Support of Hypotheses": 0.462794,
    "Support or Weakening of Models": null,
    "Compare or Combine": 0.410753,
    "Creating Figures": 0.432998,
    "Interpolation & Extrapolation": 0.588141,
    "New Information": 0.346141,
    "Select Data & Features": 0.708463,
    Terminology: 0.668094,
    "Text & Representations": 0.436404,
    "Variables & Mathematical Relationships": 0.339238,
    Comparison: 0.776517,
    Control: 0.679224,
    Hypothesis: null,
    Methods: 0.261538,
    "Precision & Accuracy": null,
    "Prediction & Further Experiments": 0.395804,
    "Text & Experiments": null,
    Tools: 0.29102,
    "Understanding Design": 0.648721
  },
  scale22: {
    "Assumptions, Strengths & Weaknesses": null,
    "Compare Models": null,
    "Consistency of Hypotheses, Predictions & Conclusions": 0.560825,
    "Model Information": 0.56078,
    "New Information & Predictions in Models": 0.653809,
    "Support of Hypotheses": 0.507232,
    "Support or Weakening of Models": null,
    "Compare or Combine": 0.426714,
    "Creating Figures": 0.515739,
    "Interpolation & Extrapolation": 0.654326,
    "New Information": 0.415957,
    "Select Data & Features": 0.756952,
    Terminology: 0.653732,
    "Text & Representations": 0.447445,
    "Variables & Mathematical Relationships": 0.397248,
    Comparison: 0.805979,
    Control: 0.72999,
    Hypothesis: null,
    Methods: 0.321649,
    "Precision & Accuracy": null,
    "Prediction & Further Experiments": 0.480895,
    "Text & Experiments": null,
    Tools: 0.336963,
    "Understanding Design": 0.674322
  },
  scale23: {
    "Assumptions, Strengths & Weaknesses": null,
    "Compare Models": null,
    "Consistency of Hypotheses, Predictions & Conclusions": 0.613754,
    "Model Information": 0.592435,
    "New Information & Predictions in Models": 0.651581,
    "Support of Hypotheses": 0.550217,
    "Support or Weakening of Models": null,
    "Compare or Combine": 0.488479,
    "Creating Figures": 0.502245,
    "Interpolation & Extrapolation": 0.694547,
    "New Information": 0.468324,
    "Select Data & Features": 0.766608,
    Terminology: 0.730874,
    "Text & Representations": 0.496125,
    "Variables & Mathematical Relationships": 0.431542,
    Comparison: 0.855974,
    Control: 0.765034,
    Hypothesis: null,
    Methods: 0.449857,
    "Precision & Accuracy": null,
    "Prediction & Further Experiments": 0.480513,
    "Text & Experiments": null,
    Tools: 0.418765,
    "Understanding Design": 0.714836
  },
  scale24: {
    "Assumptions, Strengths & Weaknesses": null,
    "Compare Models": null,
    "Consistency of Hypotheses, Predictions & Conclusions": 0.652321,
    "Model Information": 0.631677,
    "New Information & Predictions in Models": 0.665405,
    "Support of Hypotheses": 0.611469,
    "Support or Weakening of Models": null,
    "Compare or Combine": 0.549379,
    "Creating Figures": 0.523111,
    "Interpolation & Extrapolation": 0.771228,
    "New Information": 0.559357,
    "Select Data & Features": 0.797692,
    Terminology: 0.79943,
    "Text & Representations": 0.55053,
    "Variables & Mathematical Relationships": 0.493416,
    Comparison: 0.865201,
    Control: 0.800908,
    Hypothesis: null,
    Methods: 0.476793,
    "Precision & Accuracy": null,
    "Prediction & Further Experiments": 0.538892,
    "Text & Experiments": null,
    Tools: 0.504378,
    "Understanding Design": 0.804928
  },
  scale25: {
    "Assumptions, Strengths & Weaknesses": null,
    "Compare Models": null,
    "Consistency of Hypotheses, Predictions & Conclusions": 0.760947,
    "Model Information": 0.714342,
    "New Information & Predictions in Models": 0.724781,
    "Support of Hypotheses": 0.659265,
    "Support or Weakening of Models": null,
    "Compare or Combine": 0.612739,
    "Creating Figures": 0.588218,
    "Interpolation & Extrapolation": 0.807151,
    "New Information": 0.649766,
    "Select Data & Features": 0.808587,
    Terminology: 0.828449,
    "Text & Representations": 0.600055,
    "Variables & Mathematical Relationships": 0.534144,
    Comparison: 0.890094,
    Control: 0.83443,
    Hypothesis: null,
    Methods: 0.627219,
    "Precision & Accuracy": null,
    "Prediction & Further Experiments": 0.62456,
    "Text & Experiments": null,
    Tools: 0.597304,
    "Understanding Design": 0.85551
  },
  scale26: {
    "Assumptions, Strengths & Weaknesses": null,
    "Compare Models": null,
    "Consistency of Hypotheses, Predictions & Conclusions": 0.801905,
    "Model Information": 0.775194,
    "New Information & Predictions in Models": 0.693694,
    "Support of Hypotheses": 0.691441,
    "Support or Weakening of Models": null,
    "Compare or Combine": 0.65868,
    "Creating Figures": 0.646582,
    "Interpolation & Extrapolation": 0.828048,
    "New Information": 0.687104,
    "Select Data & Features": 0.840968,
    Terminology: 0.862814,
    "Text & Representations": 0.677928,
    "Variables & Mathematical Relationships": 0.593258,
    Comparison: 0.92389,
    Control: 0.858859,
    Hypothesis: null,
    Methods: 0.638095,
    "Precision & Accuracy": null,
    "Prediction & Further Experiments": 0.694856,
    "Text & Experiments": null,
    Tools: 0.62086,
    "Understanding Design": 0.816772
  },
  scale27: {
    "Assumptions, Strengths & Weaknesses": null,
    "Compare Models": null,
    "Consistency of Hypotheses, Predictions & Conclusions": 0.8,
    "Model Information": 0.797692,
    "New Information & Predictions in Models": 0.6875,
    "Support of Hypotheses": 0.739763,
    "Support or Weakening of Models": null,
    "Compare or Combine": 0.737949,
    "Creating Figures": 0.649203,
    "Interpolation & Extrapolation": 0.911765,
    "New Information": 0.738358,
    "Select Data & Features": 0.84761,
    Terminology: 0.869894,
    "Text & Representations": 0.70528,
    "Variables & Mathematical Relationships": 0.634191,
    Comparison: 0.91973,
    Control: 0.866379,
    Hypothesis: null,
    Methods: 0.783333,
    "Precision & Accuracy": null,
    "Prediction & Further Experiments": 0.720282,
    "Text & Experiments": null,
    Tools: 0.707108,
    "Understanding Design": 0.88174
  },
  scale28: {
    "Assumptions, Strengths & Weaknesses": null,
    "Compare Models": null,
    "Consistency of Hypotheses, Predictions & Conclusions": 0.81,
    "Model Information": 0.841124,
    "New Information & Predictions in Models": 0.752747,
    "Support of Hypotheses": 0.777473,
    "Support or Weakening of Models": null,
    "Compare or Combine": 0.780925,
    "Creating Figures": 0.677054,
    "Interpolation & Extrapolation": 0.942635,
    "New Information": 0.844193,
    "Select Data & Features": 0.875826,
    Terminology: 0.917375,
    "Text & Representations": 0.758242,
    "Variables & Mathematical Relationships": 0.708924,
    Comparison: 0.907932,
    Control: 0.901099,
    Hypothesis: null,
    Methods: 0.9,
    "Precision & Accuracy": null,
    "Prediction & Further Experiments": 0.771955,
    "Text & Experiments": null,
    Tools: 0.77762,
    "Understanding Design": 0.929178
  },
  scale29: {
    "Assumptions, Strengths & Weaknesses": null,
    "Compare Models": null,
    "Consistency of Hypotheses, Predictions & Conclusions": 0.8,
    "Model Information": 0.877641,
    "New Information & Predictions in Models": 0.871429,
    "Support of Hypotheses": 0.8,
    "Support or Weakening of Models": null,
    "Compare or Combine": 0.835681,
    "Creating Figures": 0.735035,
    "Interpolation & Extrapolation": 0.922535,
    "New Information": 0.809859,
    "Select Data & Features": 0.902876,
    Terminology: 0.923709,
    "Text & Representations": 0.817857,
    "Variables & Mathematical Relationships": 0.701585,
    Comparison: 0.924296,
    Control: 0.892857,
    Hypothesis: null,
    Methods: 0.891892,
    "Precision & Accuracy": null,
    "Prediction & Further Experiments": 0.838028,
    "Text & Experiments": null,
    Tools: 0.809859,
    "Understanding Design": 0.927817
  },
  scale30: {
    "Assumptions, Strengths & Weaknesses": null,
    "Compare Models": null,
    "Consistency of Hypotheses, Predictions & Conclusions": 0.837037,
    "Model Information": 0.891481,
    "New Information & Predictions in Models": 0.903509,
    "Support of Hypotheses": 0.833333,
    "Support or Weakening of Models": null,
    "Compare or Combine": 0.848889,
    "Creating Figures": 0.787778,
    "Interpolation & Extrapolation": 0.948889,
    "New Information": 0.862222,
    "Select Data & Features": 0.873407,
    Terminology: 0.92,
    "Text & Representations": 0.833333,
    "Variables & Mathematical Relationships": 0.787407,
    Comparison: 0.96,
    Control: 0.877193,
    Hypothesis: null,
    Methods: 0.814815,
    "Precision & Accuracy": null,
    "Prediction & Further Experiments": 0.823333,
    "Text & Experiments": null,
    Tools: 0.815556,
    "Understanding Design": 0.933333
  },
  scale31: {
    "Assumptions, Strengths & Weaknesses": null,
    "Compare Models": null,
    "Consistency of Hypotheses, Predictions & Conclusions": 0.913043,
    "Model Information": 0.941011,
    "New Information & Predictions in Models": 0.806818,
    "Support of Hypotheses": 0.838068,
    "Support or Weakening of Models": null,
    "Compare or Combine": 0.926966,
    "Creating Figures": 0.839888,
    "Interpolation & Extrapolation": 0.90309,
    "New Information": 0.912921,
    "Select Data & Features": 0.921067,
    Terminology: 0.926966,
    "Text & Representations": 0.803977,
    "Variables & Mathematical Relationships": 0.768258,
    Comparison: 0.941011,
    Control: 0.931818,
    Hypothesis: null,
    Methods: 0.869565,
    "Precision & Accuracy": null,
    "Prediction & Further Experiments": 0.890449,
    "Text & Experiments": null,
    Tools: 0.910112,
    "Understanding Design": 0.983146
  },
  scale32: {
    "Assumptions, Strengths & Weaknesses": null,
    "Compare Models": null,
    "Consistency of Hypotheses, Predictions & Conclusions": null,
    "Model Information": null,
    "New Information & Predictions in Models": null,
    "Support of Hypotheses": null,
    "Support or Weakening of Models": null,
    "Compare or Combine": null,
    "Creating Figures": null,
    "Interpolation & Extrapolation": null,
    "New Information": null,
    "Select Data & Features": null,
    Terminology: null,
    "Text & Representations": null,
    "Variables & Mathematical Relationships": null,
    Comparison: null,
    Control: null,
    Hypothesis: null,
    Methods: null,
    "Precision & Accuracy": null,
    "Prediction & Further Experiments": null,
    "Text & Experiments": null,
    Tools: null,
    "Understanding Design": null
  },
  scale33: {
    "Assumptions, Strengths & Weaknesses": null,
    "Compare Models": null,
    "Consistency of Hypotheses, Predictions & Conclusions": 0.933333,
    "Model Information": 0.920261,
    "New Information & Predictions in Models": 0.918033,
    "Support of Hypotheses": 0.881148,
    "Support or Weakening of Models": null,
    "Compare or Combine": 0.898039,
    "Creating Figures": 0.790196,
    "Interpolation & Extrapolation": 0.968627,
    "New Information": 0.964706,
    "Select Data & Features": 0.936601,
    Terminology: 0.966013,
    "Text & Representations": 0.893443,
    "Variables & Mathematical Relationships": 0.814379,
    Comparison: 0.933333,
    Control: 0.934426,
    Hypothesis: null,
    Methods: 0.888889,
    "Precision & Accuracy": null,
    "Prediction & Further Experiments": 0.929412,
    "Text & Experiments": null,
    Tools: 0.956863,
    "Understanding Design": 0.952941
  },
  scale34: {
    "Assumptions, Strengths & Weaknesses": null,
    "Compare Models": null,
    "Consistency of Hypotheses, Predictions & Conclusions": 1.0,
    "Model Information": 0.964912,
    "New Information & Predictions in Models": 0.888889,
    "Support of Hypotheses": 0.872222,
    "Support or Weakening of Models": null,
    "Compare or Combine": 0.97076,
    "Creating Figures": 0.912281,
    "Interpolation & Extrapolation": 0.959064,
    "New Information": 0.929825,
    "Select Data & Features": 0.924561,
    Terminology: 0.916179,
    "Text & Representations": 0.916667,
    "Variables & Mathematical Relationships": 0.862573,
    Comparison: 0.935673,
    Control: 0.933333,
    Hypothesis: null,
    Methods: 1.0,
    "Precision & Accuracy": null,
    "Prediction & Further Experiments": 0.95614,
    "Text & Experiments": null,
    Tools: 0.964912,
    "Understanding Design": 0.953216
  },
  scale35: {
    "Assumptions, Strengths & Weaknesses": null,
    "Compare Models": null,
    "Consistency of Hypotheses, Predictions & Conclusions": 0.971429,
    "Model Information": 0.850099,
    "New Information & Predictions in Models": 0.978723,
    "Support of Hypotheses": 0.984043,
    "Support or Weakening of Models": null,
    "Compare or Combine": 0.994083,
    "Creating Figures": 0.973373,
    "Interpolation & Extrapolation": 1.0,
    "New Information": 0.964497,
    "Select Data & Features": 0.966469,
    Terminology: 1.0,
    "Text & Representations": 0.952128,
    "Variables & Mathematical Relationships": 0.947732,
    Comparison: 0.988166,
    Control: 0.978723,
    Hypothesis: null,
    Methods: 1.0,
    "Precision & Accuracy": null,
    "Prediction & Further Experiments": 0.982249,
    "Text & Experiments": null,
    Tools: 1.0,
    "Understanding Design": 1.0
  },
  scale36: {
    "Assumptions, Strengths & Weaknesses": null,
    "Compare Models": null,
    "Consistency of Hypotheses, Predictions & Conclusions": 1.0,
    "Model Information": 1.0,
    "New Information & Predictions in Models": 1.0,
    "Support of Hypotheses": 0.980769,
    "Support or Weakening of Models": null,
    "Compare or Combine": 1.0,
    "Creating Figures": 0.982759,
    "Interpolation & Extrapolation": 1.0,
    "New Information": 1.0,
    "Select Data & Features": 0.993103,
    Terminology: 1.0,
    "Text & Representations": 1.0,
    "Variables & Mathematical Relationships": 0.982759,
    Comparison: 1.0,
    Control: 1.0,
    Hypothesis: null,
    Methods: 1.0,
    "Precision & Accuracy": null,
    "Prediction & Further Experiments": 1.0,
    "Text & Experiments": null,
    Tools: 1.0,
    "Understanding Design": 1.0
  }
}

export default tsDataScience
